export const uploadsHistoryTranslation = {
  actions: {
    continue: 'Kontynuuj',
    downloadFile: 'Pobierz wgrany plik',
    resolveErrors: 'Rozwiąż błędy',
    showImportScope: 'Podejrzyj zakres importu',
    viewResolvedErrors: 'Podejrzyj rozwiązane błędy',
  },
  columns: {
    actions: 'Akcje',
    createdAt: 'Data utworzenia',
    creator: 'Twórca',
    fileName: 'Nazwa pliku',
    progress: 'Postęp',
    status: 'Status',
    type: 'Typ',
  },
  filters: {
    status: 'Status',
    uploadType: 'Typ uploadu',
  },
  importScope: {
    closeButton: 'Zamknij',
    description: 'Spółki znalezione w pliku {{fileName}} i to, co objął import.',
    imported: 'zaimportowana',
    rowCount: 'wiersze: {{rows}}',
    selectedButAbsent:
      'Wybrano spółki, których w pliku nie było: {{companies}}. Nie zaimportowano z nich nikogo.',
    skipped: 'pominięta',
    title: 'Zakres importu',
    total: 'Zaimportowanych wierszy: {{rows}}',
  },
  status: {
    AWAITING_VALIDATION_RESOLUTION: 'Oczekiwanie na rozwiązanie',
    ERROR: 'Błąd',
    FINISHED: 'Zakończono',
    IN_PROGRESS: 'W toku',
    NOT_STARTED: 'Nie rozpoczęto',
    PROCESSING_CHUNKS: 'Przetwarzanie fragmentów',
    READING_DOCUMENT: 'Wczytywanie dokumentu',
    VALIDATION_FAILED: 'Błąd walidacji',
  },
  title: 'Historia uploadów',
  types: {
    CHAT_DOCUMENT: 'Dokument czatu',
    COMPANY_POSITIONS: 'Stanowiska',
    DEVELOPMENT_ACTIVITIES: 'Aktywności rozwojowe',
    DEVELOPMENT_CENTER: 'Development Center',
    DEVELOPMENT_CENTER_REPORTS: 'Raporty Development Center',
    DOCUMENT: 'Dokument',
    EDUAKCJA: 'Edukacja',
    EMPLOYEE_DATA: 'Dane pracowników',
    EMPLOYEES: 'Pracownicy',
    EMPLOYEES_EMPLOYMENT_HISTORY: 'Historia zatrudnienia',
    EMPLOYEES_ENABLE_CHANGE: 'Zmiana aktywności',
    MDR: 'MDR',
    SUCCESSION_DATA: 'Dane sukcesji',
    SYSTEM_USERS: 'Użytkownicy systemu',
  },
};

export type UploadsHistoryTranslation = typeof uploadsHistoryTranslation;
